import ModalComponent from './Modal';
import InventoryModalComponent from './InventoryModal';

const Modal = ModalComponent;
const InventoryModal = InventoryModalComponent;

export default Modal;
export { InventoryModal };
